import React, { useEffect } from "react"
import { Button } from "@/components/ui/button"

interface MobileFooterButtonsProps {
  formEdited: boolean
  activeTab?: string
  handleCancel: () => void
  handleSave: (e?: React.MouseEvent<HTMLButtonElement>) => void
  isDisabled?: boolean
  tabToShow?: string
}

const MobileFooterButtons = ({
  formEdited,
  activeTab,
  handleCancel,
  handleSave,
  isDisabled = false,
  tabToShow,
}: MobileFooterButtonsProps) => {
  // Only show when form is edited and either:
  // - No tabToShow is specified (show on any tab)
  // - No activeTab is provided (show regardless of tab)
  // - We're on the specified tab
  if (!formEdited) {
    console.log("MobileFooterButtons hidden: No edits detected")
    return null
  }

  if (tabToShow && activeTab && activeTab !== tabToShow) {
    console.log("MobileFooterButtons hidden: Not on the right tab")
    return null
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 flex justify-center gap-4 z-50">
      <Button
        variant="outline"
        onClick={handleCancel}
        className="w-[120px]"
        disabled={isDisabled}
      >
        Cancel
      </Button>
      <Button onClick={handleSave} className="w-[120px]" disabled={isDisabled}>
        Save Changes
      </Button>
    </div>
  )
}

export default MobileFooterButtons
